import { PendingContentItem } from "../../components/molcules/PendingContentItem";

const PendingPage = () => {
  return (
    <>
      <PendingContentItem />
    </>
  );
};

export default PendingPage;
